export default "__VITE_ASSET__C_xangDi__"